<template>
  <div>
    <load-profile></load-profile>
    <b-card>
      <b-card-text class="mb-2">
        <h5>
          {{ $t("general.customizeBusinessInfo") }}
        </h5>
      </b-card-text>
      <validation-observer ref="editForm" #default="{ invalid }">
        <n-form-confirmation
          key="editForm"
          @submit="validateForm"
          :form="$refs.editForm"
          :disabled="invalid"
        >
          <n-input
            :fields="fields"
            v-model="data"
            :initValue="initData"
          ></n-input>
          <b-row>
            <b-col cols="12" class="text-right">
              <n-button-loading
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                type="submit"
                variant="primary"
                class="mt-1"
                :loading="loading"
                :disabled="invalid"
                v-if="$can('update', permissionType)"
              >
                {{ $t("button.saveChanges") }}
              </n-button-loading>
            </b-col>
          </b-row>
        </n-form-confirmation>
      </validation-observer>
    </b-card>

    <b-card v-if="listMerchant.length > 0">
      <b-card-text class="mb-2">
        <h3>
          {{ $t("general.partnersGroup") }}
        </h3>
      </b-card-text>

      <b-row>
        <b-col cols="12">
          <b-list-group v-for="(item, index) in listMerchant" :key="index">
            <b-list-group-item>
              <b-row>
                <b-col cols="12" class="d-flex align-items-center">
                  <b-avatar
                    size="80"
                    :src="item.logoUrl"
                    variant="primary"
                    :text="avatarText(item.companyName)"
                    class="mr-3"
                  ></b-avatar>
                </b-col> </b-row
              ><br />
              <b-row>
                <b-col cols="12">
                  <span>
                    <feather-icon icon="StarIcon" />
                    {{ item.companyName }} </span
                  ><br />
                  <span>
                    <feather-icon icon="GridIcon" />
                    {{ item.businessType }}
                  </span>
                  <br />
                  <span>
                    <feather-icon icon="HashIcon" />
                    {{ item.id }}
                  </span>
                </b-col>
              </b-row> </b-list-group-item
            ><br />
          </b-list-group>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>
<script>
import {
  BRow,
  BCol,
  BCard,
  BCardText,
  BLink,
  BAvatar,
  BListGroup,
  BListGroupItem,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import NButtonLoading from "@/components/NButtonLoading";
import NFormConfirmation from "@/components/NFormConfirmation";
import NInput from "@/components/NInput";
import FormInput from "./formInput";
import Repository from "@/repositories/RepositoryFactory";
import useJwt from "@/auth/jwt/useJwt";
import { avatarText } from "@core/utils/filter";

const MerchantRepository = Repository.get("merchant");
const PartnersShipRepository = Repository.get("partnersShip");

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardText,
    BLink,
    BAvatar,
    BListGroup,
    BListGroupItem,
    NButtonLoading,
    NFormConfirmation,
    NInput,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      data: {
        companyName: null,
        businessTypeId: null,
      },
      avatarText,
      initData: {},
      loading: false,
      listMerchant: [],
    };
  },
  computed: {
    userData: function () {
      return this.$store.state.profile.email || this.$store.state.profile.phone  
        ? this.$store.state.profile
        : JSON.parse(
            localStorage.getItem(useJwt.jwtConfig.storageUserDataKeyName)
          );
    },
  },
  mounted() {
    this.show();
    this.getPartnerShip();
  },
  methods: {
    getPartnerShip() {
      PartnersShipRepository.show()
        .then((response) => {
          const data = response.data.data;
          this.listMerchant = [...data.list];
          console.log("getPartnerShip: ", response.data.data);
        })
        .catch();
    },
    show() {
      this.loading = true;
      MerchantRepository.show()
        .then((response) => {
          this.initData = {
            ...response.data.data,
          };
          console.log("ggg: ", {
            ...response.data.data,
          });
          console.log("show: ", response.data.data);
        })
        .catch()
        .then(() => {
          this.loading = false;
        });
    },
    validateForm() {
      this.$refs.editForm.validate().then((success) => {
        if (success) {
          this.submit();
        }
      });
    },
    submit() {
      this.loading = true;
      MerchantRepository.update(this.data)
        .then((response) => {
          const data = response?.data?.data;
          if (data) {
            let user = JSON.parse(
              localStorage.getItem(useJwt.jwtConfig.storageUserDataKeyName)
            );
            user.companyName = data.companyName;

            localStorage.setItem(
              useJwt.jwtConfig.storageUserDataKeyName,
              JSON.stringify(user)
            );
            this.$store.commit("profile/UPDATE_PROFILE", user);
          }
        })
        .catch()
        .then(() => {
          this.loading = false;
        });
    },
    back() {
      this.$router.back();
    },
  },
  setup() {
    const fields = FormInput;
    const permissionType = "modify-business-info";

    return { fields, permissionType };
  },
};
</script>
